import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { Spinner } from '@flipster/react/design-system/spinner';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { mintBunja, mintFormBunja } from './state';

const ExchangeDesc = () => {
  const t = useTranslations();
  const { mintOverviewAtom, mintExchangeRateAtom } = useBunja(mintBunja);
  const { fromCurrencyAtom } = useBunja(mintFormBunja);
  const fromCurrency = useAtomValue(fromCurrencyAtom);
  const mintOverview = useAtomValue(mintOverviewAtom);
  const mintExchangeRate = useAtomValue(mintExchangeRateAtom);

  const exchangeRateToolTipBody = mintOverview?.exchangeRateToolTipBody;
  const estProcessingTimeInMins = mintOverview?.estProcessingTimeInMins;
  const exchangeRate = mintExchangeRate?.rate;

  return (
    <div className={stack({ gap: 4, textStyle: 'Text/M/Monospace/Regular', color: 'content.default.level-5' })}>
      <div className={hstack({ justify: 'flex-end', gap: 4 })}>
        <div className={hstack({ gap: 4, alignItems: 'center' })}>
          <span>1 {fromCurrency}</span>
          <span>≈</span>
          <span className={css({ lineHeight: 0 })}>{exchangeRate ?? <Spinner size={16} color='gray' />}</span>
        </div>
        <Tooltip placement='top' shape='white'>
          <Tooltip.Trigger css={{ h: 16 }}>
            <InformationCircleIcon size={16} />
          </Tooltip.Trigger>
          <Tooltip.Content>
            <p>{exchangeRateToolTipBody}</p>
          </Tooltip.Content>
        </Tooltip>
      </div>
      <p className={css({ textAlign: 'right' })}>
        {t('Common.r251008.Est_processing_time_colon_m', { minute: estProcessingTimeInMins })}
      </p>
    </div>
  );
};

export default ExchangeDesc;
